import { useEffect, useState } from 'react'
import UserApiManager from '../../api/services/UserApiManager'
import OperatorsApiManager from '../../api/services/OperatorsApiManager'
import { Link } from 'react-router-dom'
import Avatar from 'react-avatar'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

function UserProfile() {
    const { t } = useTranslation()
    const [username, setUsername] = useState(() => {
        var userData = localStorage.getItem('userData')
        if (userData) {
            return JSON.parse(userData)?.username
        }

        return t('user')
    })
    const [operadores, setOperadores] = useState([])
    const [firstName, setFirstName] = useState('')
    const [mail, setMail] = useState('')
    const [avatar, setAvatar] = useState('')

    useEffect(() => {
        fetchUserData()
        fetchOperadores()
    }, [])
    async function fetchOperadores() {
        const operadoresItems = await OperatorsApiManager.getUserOperatorsV1()

        const operadores = operadoresItems.map((operador) => (
            <label className="badge badge-outline-dark my-1 me-1">
                {operador.nombre_operador}
            </label>
        ))
        setOperadores(operadores)
    }
    async function fetchUserData() {
        const userDataApi = await UserApiManager.getUser()
        if (userDataApi) {
            const data = userDataApi
            setUsername(data.name[0].value)
            setMail(data.mail[0].value)
            setFirstName(data.field_first_name[0]?.value)
            setAvatar(data.user_picture[0]?.url)
        }
    }
    return (
        <>
            <div className="page-header">
                <h3 className="page-title">{t('my_profile')}</h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a
                                href="!#"
                                onClick={(event) => event.preventDefault()}
                            >
                                {t('user')}
                            </a>
                        </li>
                        <li
                            className="breadcrumb-item active"
                            aria-current="page"
                        >
                            {t('my_profile')}
                        </li>
                    </ol>
                </nav>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="border-bottom text-center pb-4">
                                        <Avatar
                                            src={avatar}
                                            name={username}
                                            size={140}
                                            email={mail}
                                            round={true}
                                            color="#3f50f6"
                                        />
                                        <div className="mb-3">
                                            <h3>{firstName}</h3>
                                            <h4>@{username}</h4>
                                        </div>
                                    </div>
                                    <div className="border-bottom py-4">
                                        <p>{t('operators_title')}</p>
                                        <div>{operadores}</div>
                                    </div>
                                    <div className="py-4">
                                        <p className="clearfix">
                                            <span className="float-start">
                                                {t('names_title')}
                                            </span>
                                            <span className="float-end text-muted">
                                                {firstName}
                                            </span>
                                        </p>
                                        <p className="clearfix">
                                            <span className="float-start">
                                                {t('email_title')}
                                            </span>
                                            <span className="float-end text-muted">
                                                {mail}
                                            </span>
                                        </p>
                                        <p className="clearfix">
                                            <span className="float-start">
                                                {t('user')}
                                            </span>
                                            <span className="float-end text-muted">
                                                {username}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="d-block d-md-flex justify-content-between mt-4 mt-md-0">
                                        <div className="d-grid gap-2 mt-4">
                                            <Link
                                                to={`/user/perfil/editar`}
                                                state={{
                                                    userEdit: {
                                                        username: username,
                                                        correo: mail,
                                                        firstName: firstName,
                                                        avatar: avatar,
                                                    },
                                                    isEdit: true,
                                                }}
                                            >
                                                <Button variant="btn btn-outline-primary" className="w-100 mb-2">
                                                    {t('button.edit_profile')}
                                                </Button>
                                            </Link>
                                            <Link
                                                to={'/user/perfil/editar/password'}
                                            >
                                                <Button variant="btn btn-outline-danger" className="w-100">
                                                    {t('button.change_password')}
                                                </Button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserProfile
